import React from "react";
import Reveal from "./Reveal";

const Contact = () => {
  return (
    <div
      id="contact"
      className="w-full md:pt-[180px] md:pb-[100px] py-14  text-black bg-[#11071F]"
    >
      <div className="flex flex-col justify-center h-full max-w-screen-lg p-4 mx-auto items-center">
        <div className="pb-6 fadein text-center flex justify-center items-center flex-col md:w-[60%] w-[100%]">
          <Reveal slidePermission={false}>
            <p className="inline p-2 md:text-5xl text-[40px] font-bold border-b4 border-gray500 text-white">
              Contact
            </p>
          </Reveal>
          <Reveal slidePermission={false}>
            <p className="pt-4 text-[#CCD6F6]  text-center md:text-xl text-base">
              Feel free to connect with me via email! You can also reach out on{" "}
              <a
                href="https://www.linkedin.com/in/firdosh01/"
                rel="noreferrer"
                target="_blank"
                className="text-[#9857D3] hover:text-white  duration-200"
              >
                LinkedIn
              </a>{" "}
              or{" "}
              <a
                href="https://x.com/md_firdosh01"
                rel="noreferrer"
                target="_blank"
                className="text-[#9857D3] hover:text-white duration-200"
              >
                Twitter
              </a>{" "}
              —whichever works best for you
            </p>
          </Reveal>
          <Reveal slidePermission={false}>
            <p className="py-4 text-[#CCD6F6]  font-medium text-[15px]md:w-[60%] w-[100%] duration-300 text-center md:text-xl text-base hover:text-white  cursor-pointer">
              <a href="mailto:mdfirdosha37@gmail.com">mdfirdosha37@gmail.com</a>
            </p>
          </Reveal>
        </div>
        {/* 
        <div className="flex justify-between md:flex-row flex-col px-1 fade-in md:px-4">
          <div>
            <div className=" font-bold text-[45px]  text-black dark:text-white">
              Let's{" "}
              <span className="text-[#DA5724]   dark:text-cyan-500">work</span>{" "}
              <br />
              together
            </div>

            <div className="flex flex-col md:mt-[50px] mt-[30px]">
              <div className="text-black dark:text-white text-[18px] font-medium">
                Mail
              </div>
              <div className=" text-black dark:text-gray-400 text-[15px]">
                <a href="mailto:mdfirdosha37@gmail.com">
                  mdfirdosha37@gmail.com
                </a>
              </div>
            </div>
            <div className="flex flex-col mt-[10px]">
              <div className="text-black dark:text-white text-[18px] font-medium">
                Contact
              </div>
              <div className=" text-black dark:text-gray-400 text-[15px]">
                <a href="tel:+918102607915">+91 8102607915</a>
              </div>
            </div>
          </div>
          <form
            onClick={handleOnSubmit}
            className="flex flex-col w-full md:w-1/2 md:mt-0 mt-[30px]"
          >
            <input
              type="text"
              name="name"
              value={name}
              onChange={handleOnChange}
              placeholder="Enter your name"
              className="p-2 text-black bg-transparent border-2 border-black rounded-md dark:text-white focus:outline-none dark:border-white"
            />
            <input
              type="text"
              name="email"
              value={email}
              onChange={handleOnChange}
              placeholder="Enter your email"
              className="p-2 mt-1 text-black bg-transparent border-2 border-black rounded-md dark:text-white focus:outline-none dark:border-white"
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="10"
              value={message}
              onChange={handleOnChange}
              className="p-2 mt-1 text-black bg-transparent border-2 border-black rounded-md dark:text-white focus:outline-none dark:border-white"
            ></textarea>

            <button
              type="submit"
              className="flex w-full text-center justify-center items-center px-6 py-3 mx-auto my-8 text-white duration-300 bg-[#DA5724] rounded-md dark:bg-gradient-to-b dark:from-cyan-500 dark:to-blue-500 hover:bg-[#da5824d8]"
            >
              Let's talk
            </button>
          </form>
        </div> */}
      </div>
      {/* <div className="flex items-start justify-center">
        <span className="text-sm font-semibold text-black dark:text-white ">Made with ❤️ by Firdosh</span>
      </div> */}
    </div>
  );
};

export default Contact;
